"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomActionBar = BottomActionBar;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/BottomActionBar/index.tsx
// Figma: BottomNavigation — 画面下部に固定される CTA バー。
//
// GlassScrollLayout の内側で position:sticky / bottom:0 として使う
// (BaseLayout の overflow により window sticky は効かないため、
//  スクロールコンテナ = GlassScrollLayout に対して貼り付く)。
//
// 構成 (上から):
//   note      — 任意。「上記の注意事項に同意して」のチェックボックスなど
//   children  — ボタン群。縦積み・8px ギャップ・中央寄せで並べる
//
// 面は background.surface (80%) + backdrop-blur + 上境界線。
// セーフエリア (ホームインジケータ) 分は下パディングで吸収する。
//
// 色は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
function BottomActionBar(_a) {
    var note = _a.note, children = _a.children;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { alignItems: "center", spacing: "".concat(tokens_1.spacing.md, "px"), sx: {
            position: 'sticky',
            bottom: 0,
            zIndex: function (theme) { return theme.zIndex.appBar; },
            boxSizing: 'border-box',
            width: '100%',
            // 短いページでも本文の下端に貼り付く
            marginTop: 'auto',
            px: "".concat(tokens_1.spacing.lg, "px"),
            pt: "".concat(tokens_1.spacing.md, "px"),
            pb: "calc(".concat(tokens_1.spacing.md, "px + env(safe-area-inset-bottom, 0px))"),
            backgroundColor: p.background.surface,
            backdropFilter: 'blur(16px)',
            // iOS/WKWebView (Capacitor) では -webkit- が無いと効かない
            WebkitBackdropFilter: 'blur(16px)',
            borderTop: "1px solid ".concat(p.border.neutral.default),
        }, children: [note, (0, jsx_runtime_1.jsx)(material_1.Stack, { alignItems: "center", spacing: "".concat(tokens_1.spacing.sm, "px"), sx: { width: '100%' }, children: children })] }));
}
